/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const SOCKET = project.getFeature(feature.getSettingValue('SOCKET'));
    if (!SOCKET) {
        return blocks;
    }
    const NAME = SOCKET.getSettingValue('NAME');
    const EVENT_TYPE = feature.getSettingValue('EVENT_TYPE');
    let eventLocation = '';

    const links = project.getNodeLinks(feature, 'sock_connection_event');
    if (links.length > 0) {
        const link = links[0];
        if (EVENT_TYPE === 'DISCONNECTED') {
            eventLocation += `
if newstatesimple=PL_SSTS_CLOSED then
    '****${link.getSourceId()}****'
end if`;
        }
        if (EVENT_TYPE === 'CONNECTED') {
            eventLocation += `
if newstatesimple=PL_SSTS_EST then
    '****${link.getSourceId()}****'
end if`;
        }
    }

    blocks.push({
        location: 'on_sock_event',
        id: `${NAME}_sock_event_${EVENT_TYPE}`,
        blockType: BlockType.CODE,
        template: `
if sock.num=${NAME}_SOCK_NUM then
    ${eventLocation}
end if
    `,
    });

    return blocks;
};
